import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@libs/types/src/common/object-type/ok.object';
import { TrashItemGridObject } from '@libs/types/src/services/object-type/trash/trash-item.object';
import { TrashSettingsUpdateInput } from '@libs/types/src/services/input-type/trash/trash-settings.update-input';
import { TrashSettingsObject } from '@libs/types/src/services/object-type/trash/trash-settings.object';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { filterFrag } from './types/filter.types';

@Injectable({ providedIn: 'root' })
export class TrashGqlService extends GqlServiceV2 {

    public getTrashItems(input: GridInput | null, fragment: string): Promise<TrashItemGridObject> {
        return this.query<TrashItemGridObject>(`
            query($input: GridInput) {
                trash {
                    filter(input: $input) {
                        ${filterFrag}
                        items {
                            ${fragment}
                        }
                    }
                }
            }
        `, { input }, { offline: false });
    }

    public restoreTrashItem(input: IdInput): Promise<OkObject> {
        return this.mutate<OkObject>(`
            mutation($input: IdInput!) {
                trash {
                    restore(input: $input) {
                        ok
                    }
                }
            }
        `, { input }, { offline: false });
    }

    public deleteTrashItem(input: IdInput): Promise<OkObject> {
        return this.mutate<OkObject>(`
            mutation($input: IdInput!) {
                trash {
                    delete(input: $input) {
                        ok
                    }
                }
            }
        `, { input }, { offline: false });
    }

    public getTrashSettings(): Promise<TrashSettingsObject> {
        return this.query<TrashSettingsObject>(`
            query {
                trash {
                    settings {
                        minimumRetentionDays
                    }
                }
            }
        `, {}, { offline: false });
    }

    public updateTrashSettings(input: TrashSettingsUpdateInput): Promise<TrashSettingsObject> {
        return this.mutate<TrashSettingsObject>(`
            mutation($input: TrashSettingsUpdateInput!) {
                trash {
                    updateSettings(input: $input) {
                        minimumRetentionDays
                    }
                }
            }
        `, { input }, { offline: false });
    }

}
